import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Grid, GridItem } from '@chakra-ui/react';
import { Fragment, useContext, useMemo } from 'react';
import { isNull, isString } from '@progress-fe/core';
import { IconButton } from '../../buttons';
import { JsFieldInspector } from '../../jsFormBase';
import { JsFormConfigContext } from '../../../contexts';
import { TableEditableValue, TableValue } from '../../tables/components';
/**
 * Component renders "/schemas/jsf-lock-table" field of JsonSchema.
 * @param props : field props come from JsonSchema.
 * Value of props.formData is TLockTableFormData.
 */
const LockTableJsFieldFC = (props) => {
    const { isInspector } = useContext(JsFormConfigContext) ?? {};
    const { fieldConfig, fieldValues } = props.formData;
    const handleFormDataChange = (value) => {
        const newFormData = { fieldConfig: fieldConfig, fieldValues: value };
        props.onChange(newFormData);
    };
    const handleChangeValue = (value, index, valIndex) => {
        if (!fieldValues) {
            return;
        }
        const fieldValuesCopy = structuredClone(fieldValues);
        const curVal = fieldValuesCopy[index].values[valIndex];
        fieldValuesCopy[index].values[valIndex] =
            isString(curVal) || isNull(curVal) ? value : { ...(curVal ?? {}), value };
        handleFormDataChange(fieldValuesCopy);
    };
    const handleChangeLock = (locked, index) => {
        if (!fieldValues) {
            return;
        }
        const fieldValuesCopy = structuredClone(fieldValues);
        fieldValuesCopy[index].locked = locked;
        handleFormDataChange(fieldValuesCopy);
    };
    const templateGrid = useMemo(() => (fieldConfig?.columns ?? []).map((col) => col.width ?? '1fr').join(' ') + ' 24px', [fieldConfig]);
    // !important used because of global gap for all divs in form
    return (_jsx(JsFieldInspector, { isActive: isInspector, fieldCode: props.name, fieldType: props.uiSchema?.['ui:field']?.toString() ?? '', valueType: ['object'], children: _jsxs(Grid, { "data-testid": "LockTableJsField-test", "data-name": props.name, gridTemplateColumns: templateGrid, overflow: 'auto', width: '100%', sx: { gap: '0!important' }, children: [fieldConfig?.columns.map((column, idx) => (_jsx(GridItem, { colSpan: idx === fieldConfig?.columns.length - 1 ? 2 : 'auto', minH: "36px", position: 'sticky', top: 0, zIndex: 1, borderBottom: '1px solid', borderColor: 'border', p: "2px", bg: 'bg', alignContent: 'center', children: column.name }, column.name))), fieldValues?.map((value, idx) => {
                    return (_jsxs(Fragment, { children: [value.values.map((val, id) => (_jsx(GridItem, { h: "24px", p: idx === 0 ? '4px 2px 2px' : '2px', children: fieldConfig?.columns[id].type ? (_jsx(TableEditableValue, { value: val ?? '', isDisabled: props.schema.readOnly, type: fieldConfig?.columns[id].type, options: fieldConfig?.columns[id].options, onChangeValue: (newValue) => {
                                        handleChangeValue(newValue, idx, id);
                                    } })) : (_jsx(TableValue, { value: val ?? '' })) }, id))), _jsx(GridItem, { position: "sticky", right: 0, p: idx === 0 ? '4px 0 2px' : '2px 0', children: _jsx(IconButton, { isDisabled: props.schema.readOnly, icon: value.locked ? 'Locked' : 'Unlocked', onClick: () => handleChangeLock(!value.locked, idx) }) })] }, idx));
                })] }) }));
};
export const LockTableJsField = LockTableJsFieldFC;
//# sourceMappingURL=LockTableJsField.js.map